import React, { useLayoutEffect } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { onBlankLayout } from 'store/slices/themeSlice'
import { AUTH_TOKEN } from 'constants/AuthConstant'

const ProtectedRoute = () => {
  const dispatch = useDispatch()
  const token = localStorage.getItem(AUTH_TOKEN)

  // 🔥 runs BEFORE paint
  useLayoutEffect(() => {
    if (token) {
      dispatch(onBlankLayout(false))
    }
  }, [token, dispatch])

  if (!token) {
    return <Navigate to="/auth/login" replace />
  }

  return <Outlet />
}

export default ProtectedRoute
